import React, { useState } from "react";
import { verifyPin } from "../services/api";

export default function PinModal({ onClose, onSuccess }) {
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const verificar = async () => {
    setError("");

    const p = String(pin || "").trim();
    if (!p) {
      setError("Ingresa el PIN");
      return;
    }

    try {
      setLoading(true);

      // ✅ valida contra backend (Cognito + MASTER_PIN en Lambda)
      const res = await verifyPin(p);
      const raw = res?.data ?? res;

      // normaliza (por si algún proxy te regresa body string)
      let normalized = raw;
      if (normalized && typeof normalized === "object" && typeof normalized.body === "string") {
        try {
          normalized = JSON.parse(normalized.body);
        } catch {
          normalized = raw;
        }
      }

      if (!normalized?.ok || !normalized?.pinToken) {
        throw new Error(normalized?.message || normalized?.error || "PIN incorrecto");
      }

      // ✅ guarda token para que api.js lo mande como X-Pin-Token en /secret
      localStorage.setItem("pinToken", normalized.pinToken);
      localStorage.setItem("pinTokenExp", String(Date.now() + 300 * 1000)); // opcional

      // ✅ respeta tu flujo actual
      await onSuccess?.();
      onClose?.();
    } catch (e) {
  const apiMsg =
    e?.response?.data?.message ||
    e?.response?.data?.error;

  setError(apiMsg || "PIN incorrecto");
}

  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-xl shadow-xl w-80">
        <h2 className="text-lg font-bold text-slate-800 mb-3">Ingresar PIN maestro</h2>

        <input
          type="password"
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") verificar();
          }}
          className="w-full border px-3 py-2 rounded-lg mb-2"
          placeholder="•••••"
          disabled={loading}
          autoFocus
        />

        {error && <p className="text-red-500 text-xs mb-2">{error}</p>}

        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1 text-slate-500 hover:text-slate-700"
            disabled={loading}
          >
            Cancelar
          </button>

          <button
            onClick={verificar}
            className="px-4 py-1 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-60"
            disabled={loading}
          >
            {loading ? "Validando..." : "Validar"}
          </button>
        </div>
      </div>
    </div>
  );
}
